import React from "react";
import Logo from '../asset/images/logo.svg'
import Store1 from '../asset/images/store.svg'
import Store2 from '../asset/images/store2.svg'
import Location from '../asset/images/location.svg'
import Email from '../asset/images/email.svg'
import Insta from '../asset/images/insta.png'
import Facebook from '../asset/images/facebook.png'
import Linkedin from '../asset/images/linkedin.png'
import Twitter from '../asset/images/twitter.png'
import HenceforthLogo from '../asset/images/henceforhtlogo.png'
import { Link } from "react-router-dom";

// import henceforthApi from "../utils/henceforthApi";
import { useState } from "react";
import henceforthApi from "../utils/henceforthApi";
import { toast } from "react-toastify";
import { validateEmail } from "../utils/validations";
const Footer = () => {
    const [email, setEmail] = useState()

    const handleSubmit = async () => {
        if (!validateEmail(email)) {
            return toast.warn("pls enter valid mail")
        }
        try {
            let data = {
                email: email,
                language: "ENGLISH"
            }

            const res = await henceforthApi.Suscribe.sendEmail(data)
            toast.success("Suscribed successfully")
            setEmail("")
        }
        catch (error) {
            toast.error(error.response?.body?.error)
        }

    }
    return (
        <>
            <footer className="footer-section pt-5">
                <div className="container ">
                    <div className="footer-border pb-5">


                        <div className="row justify-content-between gy-4 py-4 ">
                            <div className="col-sm-6 col-md-4 col-lg-3">
                                <div className="text-center text-sm-start">
                                    <div className="footer-logo">
                                        <img src={Logo} alt="img" className="img-fluid" />
                                        <p className="m-0 py-3">Let’s Connect Simply with the People And Send & Receive Coins!</p>
                                    </div>
                                    <div className="d-flex flex-row flex-sm-column justify-content-center align-items-center align-items-sm-start">


                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4 col-lg-2">
                                <div>
                                    <ul className="text-center text-md-start">
                                        <li className="heading">App Links</li>
                                        <li>
                                            {/* <a href={`https://play.google.com/store/apps`}> */}
                                            <a href='https://play.google.com/store/apps/details?id=com.hf.shadowz&hl=en_IN' target="_blank">

                                                <button className="btn p-0"><img src={Store1} alt="img" /></button></a>
                                            {/* </a> */}
                                        </li>
                                        {/* <a href={`https://www.apple.com/app-store`}> */}
                                        <li>
                                            <a href='https://apps.apple.com/in/app/shadowz/id6747656833' target="_blank">
                                                <button className="btn p-0"><img src={Store2} alt="img" /></button>
                                            </a>
                                        </li>
                                        {/* </a> */}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-4 col-lg-3">
                                <div>
                                    <ul className="text-center text-sm-start">
                                        <li className="heading">Contact Us</li>
                                        {/* <li>  <div className="d-flex gap-3 justify-content-center justify-content-sm-start align-items-center mb-3">
                                                <img src={Location} alt="img" />
                                                <p className="m-0">4140 Parker Rd. Allentown, New Mexico 31134</p>
                                            </div></li> */}
                                        <li>
                                            <a href={`https://mail.google.com/mail/u/0/#inbox`}>
                                                <div className="d-flex gap-3 align-items-center justify-content-center justify-content-sm-start" style={{ cursor: "pointer" }}>
                                                    <img src={Email} alt="img" />
                                                    <p className="m-0">shadowzapps@gmail.com</p>
                                                </div>
                                            </a></li>

                                    </ul>
                                </div>
                            </div>
                            <div className="col-12 col-md-8  col-lg-3">
                                <div className="text-center text-sm-start">
                                    <ul>
                                        <li className="heading">Subscribe</li>
                                        <li>
                                            <p>Subscribe to stay tuned for new app design and latest updates. Let's do it! </p>
                                        </li>
                                        <li>
                                            <form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
                                                <div className="row align-items-center my-3 mb-4">
                                                    <div className="col-8 pe-0">
                                                        <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control placeholder-text rounded-0" id="exampleFormControlInput1" placeholder="Enter your email Address" />
                                                    </div>
                                                    <div className="col-4">
                                                        <div>
                                                            <button className="btn w-100 btn-light rounded-0 subs">Subscribe</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </li>
                                        <li>

                                        </li>
                                        <li>

                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-4 footer-2 flex-wrap gap-3">
                        <p className="m-0">	&#169;2023 All Rights Reserved</p>
                    <div>
                            <a href="https://henceforthsolutions.com" target="_blank" rel="noreferrer" className="d-flex align-items-center justify-content-center justify-content-sm-start mb-sm-0 mb-3 gap-2 text-decoration-none">
                                <p className="text-white m-0">Technology by</p>
                                <img
                                    src={HenceforthLogo}
                                    alt="Technology by Henceforth Solutions"
                                    style={{ height: "30px", objectFit: "contain" }}/>
                            </a>
                        </div>
                        <div>
                            <ul className="d-flex gap-3 m-0">
                                <li><a href=""><img src={Facebook} alt="img" /></a></li>
                                <li><a href=""><img src={Insta} alt="img" /></a></li>
                                <li><a href=""><img src={Linkedin} alt="img" /></a></li>
                                <li><a href=""><img src={Twitter} alt="img" /></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
export default Footer